export default __webpack_public_path__ + "assets/219f1158ff7db3f3301622cedd5653af.svg";